var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadCsv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22783 11.0547L5.10649 12.0547C5.34916 12.3307 5.76916 12.3573 6.04649 12.116L8.66649 9.82V19.3333C8.66649 19.7013 8.96516 20 9.33316 20H10.6665C11.0345 20 11.3332 19.7013 11.3332 19.3333V9.82L13.9532 12.116C14.2292 12.3573 14.6492 12.3307 14.8932 12.0547L15.7718 11.056C16.0158 10.7787 15.9878 10.356 15.7105 10.1133L10.4385 5.49867C10.1865 5.27867 9.81183 5.27867 9.55983 5.49867L4.28916 10.1133C4.01183 10.356 3.98383 10.7787 4.22783 11.0547Z",
    fill: "#101821"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66659 2.66699L17.3333 2.66699C17.7013 2.66699 17.9999 2.36833 17.9999 2.00033V0.666991C17.9999 0.298991 17.7013 0.000324249 17.3333 0.000324249L2.66659 0.000324249C2.29859 0.000324249 1.99992 0.298991 1.99992 0.666991V2.00033C1.99992 2.36833 2.29859 2.66699 2.66659 2.66699Z",
    fill: "#101821"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCsv);
export default __webpack_public_path__ + "static/media/upload-csv.29afdf58.svg";
export { ForwardRef as ReactComponent };